import {Scope} from 'Shared/constants/Scope';

type RequireScopeProps = {
  scope: Scope;
  scopes: Scope[];
  children: JSX.Element;
};

export const hasScope = (scopes: Scope[]) => (scope: Scope) => scopes.includes(scope);

const RequireScope = (props: RequireScopeProps) => {
  return props.scopes.includes(props.scope) ? props.children : null;
};

export default RequireScope;
